import { useContext, useState } from "react";
import { useMutation } from "@apollo/client";
//Import from project
import { AuthContext } from "../../../Context/AuthContext";
import { DELETE_BOOK_CONTENT } from "../../../Schema/BookContent";
import { useDeleteImageServer } from "../../CropImage/DeleteImageServer";

const useDeleteBookContent = ({ handleClose, setRefetch, editData }) => {
  // Change Language
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const mutationDelete = useDeleteImageServer();

  const [deleteBookContent] = useMutation(DELETE_BOOK_CONTENT, {
    onCompleted: ({ deleteBookContent }) => {
      setLoading(false);
      if (deleteBookContent?.isSuccess === true) {
        setAlert(true, "success", deleteBookContent?.message);
        handleClose();
        setRefetch();

        if (editData?.image) {
          let splitSrc = editData?.image?.split(":")[4];
          mutationDelete.mutate({
            storage: "sr_music_academy",
            folder: "sr_music_images",
            file: splitSrc.split("/")[0],
          });
        }
      } else {
        setAlert(true, "error", deleteBookContent?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  const handleDelete = () => {
    setLoading(true);
    deleteBookContent({
      variables: {
        id: editData?._id,
      },
    });
  };

  return { deleteBookContent, loading, setLoading, handleDelete };
};

export default useDeleteBookContent;
